export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-16 overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/80 via-background-50 to-background-100/40" />

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-4">
              <span className="px-3 py-1 text-xs font-medium bg-primary-100/70 text-primary-700 rounded-full whitespace-nowrap">韩漫</span>
              <span className="px-3 py-1 text-xs font-medium bg-accent-100/80 text-accent-800 rounded-full whitespace-nowrap">日漫</span>
              <span className="px-3 py-1 text-xs font-medium bg-secondary-100/80 text-secondary-800 rounded-full whitespace-nowrap">国漫</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-4">
              妖精动漫 — 韩漫日漫国漫免费全集阅读平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading mb-6">
              下拉式流畅翻页，好看漫画追更不停
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              妖精动漫是国内领先的漫画在线阅读平台，全面覆盖韩国漫画、日本漫画与国产漫画。无论你是韩漫恋爱党、日漫热血粉还是国漫忠实读者，在这里都能找到心仪的作品。平台每日同步更新热门连载，海量完结佳作随心畅读，下拉式翻页技术带来丝滑阅读体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">5万+</p>
                <p className="text-xs text-foreground-500 mt-1">漫画资源</p>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block" />
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-500">300+</p>
                <p className="text-xs text-foreground-500 mt-1">每日更新章节</p>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block" />
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-secondary-500">100%</p>
                <p className="text-xs text-foreground-500 mt-1">完全免费</p>
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                开始阅读
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium text-sm rounded-full hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                下载APP
                <i className="ri-download-line" />
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-lg">
              <div className="absolute -inset-4 bg-primary-100/40 rounded-3xl blur-3xl" />
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20warm%20toned%20illustration%20featuring%20floating%20colorful%20manga%20panels%20and%20comic%20pages%20with%20Japanese%20Korean%20and%20Chinese%20art%20styles%20blending%20harmoniously%2C%20soft%20coral%20and%20amber%20gradient%20atmosphere%2C%20dynamic%20yet%20clean%20composition%2C%20artistic%20editorial%20design%20with%20warm%20lighting&width=700&height=560&seq=hero-main-visual&orientation=landscape"
                alt="妖精动漫 — 韩漫日漫国漫免费全集阅读平台主视觉"
                className="relative w-full h-auto rounded-2xl object-cover"
                width={700}
                height={560}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}